import React from 'react';
import RenderSearchBar from './RenderSearchBar';

const ReturnSearchBar = () => {
  return <RenderSearchBar />;
};

export default ReturnSearchBar;
